module.exports = __webpack_public_path__ + "img/p6.9194a1c5.png";